import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "lhpe-option-snack-group",
  templateUrl: "./option-snack-group.component.html",
  styleUrls: ["./option-snack-group.component.scss"],
})
export class OptionSnackGroupComponent implements OnInit {
  @Input() type?: string;

  constructor() {}

  ngOnInit(): void {}
}
